import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home({ user }) {
  return (
    <div className="home-page">
      {/* Hero */}
      <div className="hero-section">
        <h1 className="hero-title">24/7 Watch Exchange</h1>
        <p className="hero-subtitle">
          Buy, sell, and trade luxury watches. Lock in prices. Finance your next piece.
        </p>
        <Link to="/listings" className="hero-btn">
          Browse Watches
        </Link>
      </div>

      {/* Section 1: Buy & Sell */}
      <div className="offering-section">
        <div className="offering-content">
          <div className="offering-label">Marketplace</div>
          <h2 className="offering-title">Buy & Sell</h2>
          <p className="offering-description">
            List or buy luxury watches with verified authentication. 
            No middlemen, no auction fees. Direct peer-to-peer transactions.
          </p>
          <Link to="/listings" className="offering-btn">
            Browse Watches
          </Link>
        </div>
      </div>

      {/* Section 2: Options */}
      <div className="offering-section offering-alt">
        <div className="offering-content">
          <div className="offering-label">Watch Options</div>
          <h2 className="offering-title">Lock In a Price</h2>
          <div className="offering-status">Coming Soon</div>
          <p className="offering-description">
            Pay a premium to secure the right to buy a watch at today's price 
            for 30, 60, or 90 days. Control assets without full commitment.
          </p>
          <Link to="/listings" className="offering-btn">
            Explore Options
          </Link>
        </div>
      </div>

      {/* Section 3: Seller Financing */}
      <div className="offering-section">
        <div className="offering-content">
          <div className="offering-label">Seller Financing</div>
          <h2 className="offering-title">Buy Now, Pay Over Time</h2>
          <p className="offering-description">
            Finance your next piece directly through the seller. Set your own terms, 
            skip the banks, and build a collection on your schedule.
          </p>
          <Link to="/listings" className="offering-btn">
            Explore Financing
          </Link>
        </div>
      </div>

      {/* Footer */}
      <footer className="home-footer">
        <p>&copy; 2026 Liber Astro. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Home;
